import React, {useEffect, useState} from 'react';
import {withRouter} from 'react-router';
import {Menu} from "antd";
import style from './CateMenu.module.css';

const CateMenu = (props) => {
    const { match, data = [], onClick, title } = props;
    const [selectedKey, setSelectedKey] = useState();

    useEffect(() => {
        match.params.cateId && setSelectedKey(match.params.cateId.toString())
    }, [match]);

    return(
        <div className={style.wrapper}>
            <div className={style.title}>{title}</div>
            {
                data.length > 0
                    ?    <Menu
                            selectedKeys={[selectedKey]}
                            mode="inline"
                            onClick={onClick}
                        >
                            {
                                data.map(item => {
                                    return(
                                        <Menu.Item key={item.id}>
                                            {item.title}
                                        </Menu.Item>
                                    );
                                })
                            }
                        </Menu>
                    :   <div style={{marginBottom: 16, height: 80}}/>
            }
        </div>
    )
};

export default withRouter(CateMenu);
